module.exports = __webpack_public_path__ + "media/06.f031a502.mp3";